module.exports = __webpack_public_path__ + "img/cry.6daa32b3.jpg";